import {
    Autocomplete,
    Checkbox,
    FormControlLabel,
    Switch,
    TextField,
    Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
    Etablissement,
    PayBudget,
} from 'routes/HumanResourcesModule/PayState/helpers/types';
import Flex from 'ui/Flex/Flex';

interface OptionalFilterSelectorProps {
    field: 'etablissement' | 'pay_budget';
    data: Etablissement[] | PayBudget[];
    isFilterActive: boolean;
    setIsFilterActive: (isFilterActive: boolean) => void;
    selectedItemIds: string[];
    setSelectedItemIds: (selectedIds: string[]) => void;
}

const OptionalFilterSelector = ({
    field,
    data,
    isFilterActive,
    setIsFilterActive,
    selectedItemIds,
    setSelectedItemIds,
}: OptionalFilterSelectorProps) => {
    const { t } = useTranslation();

    const translationKey =
        field === 'etablissement' ? 'Etablissement' : 'Budget';

    return (
        <Flex direction="column">
            <Flex align="center">
                <FormControlLabel
                    control={
                        <Switch
                            id="isFilterActive"
                            color="primary"
                            checked={isFilterActive}
                            onChange={() => setIsFilterActive(!isFilterActive)}
                        />
                    }
                    disableTypography
                    label={
                        <Typography variant="body1" display="inline">
                            {t(
                                `humanResources.shouldDisplay${translationKey}s`,
                            )}
                        </Typography>
                    }
                />
            </Flex>
            {isFilterActive && data && (
                <Autocomplete
                    loadingText={t('common.loading')}
                    sx={{ mt: 1 }}
                    multiple
                    id={`selected${translationKey}SoftwareIds`}
                    disableCloseOnSelect
                    //filterOptions={(options, state) =>
                    //    options.filter((option) =>
                    //        option?.name
                    //            ?.toLowerCase()
                    //            .includes(state.inputValue.toLowerCase()),
                    //    )
                    //}
                    options={data}
                    getOptionLabel={(option) => option?.name ?? ''}
                    renderOption={(props, option, { selected }) => {
                        const { key, ...optionProps } = props;
                        return (
                            <li key={key.softwareId} {...optionProps}>
                                <Checkbox
                                    style={{ marginLeft: 8 }}
                                    checked={selected}
                                />
                                {option?.name ?? ''}
                            </li>
                        );
                    }}
                    defaultValue={data}
                    noOptionsText={t('common.noResult')}
                    value={selectedItemIds.map((id) =>
                        data.find((value) => value.softwareId === id),
                    )}
                    onChange={(_, newValue) => {
                        setSelectedItemIds(
                            newValue.map((value) => value!.softwareId),
                        );
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={t(`humanResources.${field}s`)}
                        />
                    )}
                />
            )}
        </Flex>
    );
};

export default OptionalFilterSelector;
